/**
 * On-Device Reminders — optional conversion goal (D10). Same shape and the same condition builder
 * as the In-App designer's Goal tab (src/components/goal). A conversion is a contact who tapped the
 * reminder and then did the goal event inside the attribution window. Never sent to devices.
 */
import React, { useEffect, useState } from 'react';
import ConditionBuilder from '../../components/goal/ConditionBuilder';
import { goalEventOptions } from '../../components/goal/goalModel';
import remindersApi from './api';

export default function ReminderGoal({ goal, onChange, cat, error }) {
  const [conversionEvents, setConversionEvents] = useState([]);
  useEffect(() => {
    let off = false;
    remindersApi.conversionEvents()
      .then(({ data: res }) => {
        const list = (res?.data?.event_conversations || res?.data?.eventConversations || []).map((e) => ({ id: e._id || e.id, name: e.event_name || e.name }));
        if (!off) setConversionEvents(list);
      })
      .catch(() => { if (!off) setConversionEvents([]); });
    return () => { off = true; };
  }, []);

  const set = (patch) => onChange({ ...goal, ...patch });
  const options = goalEventOptions(conversionEvents, (cat.eventList || []).map((e) => e.event), goal.event);
  const groups = [...new Set(options.map((o) => o.group))];
  const props = (cat.events && cat.events[goal.event] && cat.events[goal.event].props) || [];

  return (
    <section className="rm-card" data-testid="reminder-goal">
      <div className="rm-card-h"><span className="rm-step">6</span><h2 className="rm-card-t">Goal <span className="rm-opt">(optional)</span></h2>
        <div style={{ marginLeft: 'auto' }}>
          <input type="checkbox" role="switch" aria-label="Measure conversions" className="rm-switch" checked={!!goal.enabled} onChange={(e) => set({ enabled: e.target.checked })} />
        </div>
      </div>
      {!goal.enabled ? (
        <p className="rm-helper" style={{ marginTop: 0 }}>Turn on to measure conversions: contacts who tap the reminder and then do an event you choose.</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
          <div style={{ maxWidth: 'calc(50% - 8px)' }}>
            <label className="rm-flabel" htmlFor="rm-goal-event">Conversion event</label>
            <select id="rm-goal-event" className={`rm-select${error ? ' rm-bad' : ''}`} value={goal.event} onChange={(e) => set({ event: e.target.value, conditions: [] })} style={{ fontFamily: 'var(--rm-font-mono)', fontSize: 13 }}>
              <option value="">Pick an event</option>
              {groups.map((g) => (
                <optgroup key={g} label={g}>{options.filter((o) => o.group === g).map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}</optgroup>
              ))}
            </select>
            {error && <p className="rm-err" data-testid="err-goal">{error}</p>}
          </div>
          <div>
            <span className="rm-flabel">Event property conditions <span className="rm-opt">(optional)</span></span>
            <ConditionBuilder conditions={goal.conditions || []} onChange={(c) => set({ conditions: c })} propertyOptions={goal.event && props.length ? props : undefined} />
          </div>
          <div style={{ display: 'flex', gap: 12, alignItems: 'flex-end', flexWrap: 'wrap' }}>
            <div style={{ width: 120 }}><label className="rm-flabel">Within</label><input className="rm-input" type="number" min="1" value={goal.window} onChange={(e) => set({ window: Number(e.target.value) })} /></div>
            <div style={{ width: 160 }}><label className="rm-flabel">Unit</label>
              <select className="rm-select" value={goal.windowUnit} onChange={(e) => set({ windowUnit: e.target.value })}><option value="minutes">minutes</option><option value="hours">hours</option><option value="days">days</option></select>
            </div>
            <p style={{ margin: '0 0 9px', fontSize: 14, color: 'var(--rm-text-body)' }}>after the tap</p>
          </div>
        </div>
      )}
    </section>
  );
}
